var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherVrenjtur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.103,
    height: 18.754,
    viewBox: "0 0 31.103 18.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M56.51,8.958a4.109,4.109,0,0,0-1.053-.14,4.172,4.172,0,0,0-4.152,3.766A4.173,4.173,0,1,0,49.263,20.4a3.934,3.934,0,0,0,.618-.051A4.171,4.171,0,0,0,55.434,22.7a7.161,7.161,0,0,0,4.956,1.775c2.742,0,5.057-1.256,5.8-2.978a4.167,4.167,0,0,0,6.359-1.763c2.125-.59,3.64-2.121,3.64-3.915,0-2.305-2.5-4.174-5.581-4.174a7.507,7.507,0,0,0-1.082.079,4.639,4.639,0,0,0-4.217-2.5,5.2,5.2,0,0,0-.617.041,4.17,4.17,0,0,0-8.186-.3",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.193,
    y1: 1,
    x2: -1.165,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#437aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67a4fe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6208",
    "data-name": "Group 6208",
    transform: "translate(-45.09 -5.721)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2389",
    "data-name": "Rectangle 2389",
    width: 35.827,
    height: 34.468,
    transform: "translate(35.826 13.644) rotate(-40.539)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherVrenjtur);
export default __webpack_public_path__ + "static/media/weather_vrenjtur.5fcab59febf4b77a3604810f41db1cf3.svg";
export { ForwardRef as ReactComponent };